<template>
  <div>
    <div class="login">

      <div class="flexBetween left-main">
        <div class="l-box">
          <div class="lb-txt j-title">
            <img src="../../assets/images/future/title.png" style="height: 7vh;" />
            <div class="tit-tip"><span>智能化</span><span>人本化</span><span>生态化</span></div>
            <div class="lb-dec">打造社区数字基底，整合社区数字运营资源，以统一信息服务平台为载体，实现资源共享和价值交换，提供高效便捷政务服务及社区管理</div>
          </div>
        </div>
        <div class="r-box">
          <img class="rb-bg" src="../../assets/images/future/main-bg.png">
          <div class="rb-form">
            <div class="login-content">
              <div v-if="firstContent==='form'">
                <div class="log-form" v-if="logFormShow">
                  <div class="right-top" @click="handleErweima()" v-if="canToggleEwm">
                    <div class="erweima"><img src="../../assets/images/digital-2.png" alt="">
                    </div>
                    <div class="white-bg"></div>
                    <div v-if="toggleBg" class="toggle-bg"></div>
                  </div>
                  <h2 class="log-tit">账号登录</h2>
                  <p class="err j-err"></p>
                  <p class="log-tip">用户名</p>
                  <p class="user">
                    <!-- 这里的 username，password 也不能改动，因为security帮我们校验的时候，就是用它来接受参数的-->
                    <input type="text" name="username" v-model="username" placeholder="用户名" required="" autofocus="" />
                  </p>
                  <p class="log-tip">密码</p>
                  <div class="pw">
                    <input :type="passwordType" id="password2" name="password2" v-model="password2" placeholder="密码"
                      required="" :disabled="passwordDisabled2" />
                    <input type="hidden" id="password" name="password" v-model="password" placeholder="密码"
                      required="" />
                    <span class="pw-eye" @click="changePw()">
                      <img id="img-eye" :src="imgEyeSrc" alt="show or hide password">
                    </span>
                  </div>
                  <div v-if="showVerify">
                    <p class="log-tip">验证码</p>
                    <div class="pw">
                      <input type="text" class="ver-input" name="verification" :disabled="passwordDisabled1"
                        v-model="password1" placeholder="验证码" />
                      <button :disabled="verificationDisabled" id="verification" @click="onSlide">{{ verification
                        }}</button>
                    </div>
                  </div>
                  <!-- 本来官网上给出这个东西的，但是不知道，为啥不会获取到对应的值，因此在上面配置的时候，直接关闭 csrf  -->
                  <input type="hidden" id="tag" value="0" />
                  <input type="hidden" name="${_csrf.parameterName}" value="${_csrf.token}" />
                  <el-button class="btn-log" type="primary" :loading="fullscreenLoading" :disabled="submitTag"
                    @click="onSubmit" style="margin-top: 12px;">登录</el-button>
                  <div class="go-register">
                    <a @click="handleForget()">忘记密码？</a>
                    <span @click="handleRegister()">没有账号，去<a>注册</a></span>
                  </div>

                  <div id="sub" type="hidden"></div>
                </div>
              </div>
              <dingding v-if="firstContent==='ewm'" @cancel="handleAccountIcon" ref="dingding" />
              <forget v-if="forgetFormShow" @cancel="handleCancel" />

            </div>

          </div>

          <img class="rb-img" src="../../assets/images/future/log-dian.png">
        </div>
      </div>
    </div>

    <!-- /////////////////////////////////////////////////////  -->
    <!-- ///////////////// 图片右滑验证 ////////////////////////  -->
    <!-- /////////////////////////////////////////////////////  -->
    <div class="slideContainer_max" ref="slideContainer_max" v-show="isShowSlide">
      <div class="mask" v-show="isShowSlide" ref="mask"></div>
      <div class="slideContainer" v-show="isShowSlide" ref="slideContainer">
        <slider-verification v-show="isShowSlide" @offMask="offMask" @successVerify="successVerify"
          ref="sliderChild"></slider-verification>
      </div>
    </div>
  </div>
</template>

<script>
import SliderVerification from "../SlideVerification"
import Forget from "./forget.vue"
import Dingding from "./dingding.vue"
//引入 https://blog.csdn.net/u010227042/article/details/129128802
import { getQueryString, httpPostSecret } from "@/utils/utils"

export default {
  name: 'digital-twin',
  components: {
    SliderVerification,
    Forget,
    Dingding
  },
  data() {
    return {
      isShowSlide: false,
      NONES: ['', undefined, null],
      username: undefined,
      password: undefined,
      password2: undefined,
      password1: undefined,
      passwordDisabled2: false,
      passwordDisabled1: false,
      forgetFormShow: false,
      submitTag: false,
      passwordType: 'password',
      imgEyeSrc: require("../../assets/images/icon-eye_close.png"),
      verificationDisabled: false,
      logFormShow: true,
      verification: "获取验证码",
      firstContent: this.$envData.firstContent, // ewm（浙政钉扫码登录）、form(账号密码登录)
      toggleBg: false,
      canToggleEwm: this.$envData.canToggleEwm === 'true',
      fullscreenLoading: false,
      showVerify: this.$envData.showVerify === 'true'
    };
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  created() {
    console.log(131, this.showVerify);
    //判断url是否包含sign
    const urlUsername = getQueryString("username");
    const sign = getQueryString("sign");
    if (urlUsername && sign) {
      console.log(urlUsername)
      console.log(sign)
      this.username = urlUsername
      this.password = sign
      this.submitTag = true
      //控制password1不提交(不加密的密码)
      this.passwordDisabled2 = true
      // $("#logForm").submit();
      this.passwordDisabled2 = false
      return;
    }

    // 判断是否显示页面密码错误提示
    let getErr = window.location.search;
    if (getErr.startsWith('?error')) {
      const errorMessage = this.getParaByName("error");
      const err = decodeURIComponent(errorMessage)
      this.$message.error(err);
    }

    if (getErr.startsWith('?forgotError')) {
      this.handleForget();
      const errorMessage = this.getParaByName("forgotError");
      const fErr = decodeURIComponent(errorMessage)
      this.$message.error(fErr);
    }
  },
  mounted() {
    // 扫码成功后需要在页面中监听扫码结果
    window.addEventListener('message', async (event) => {
      if (!event.data || !event.data.code) return
      const url = "/api/user/loginByZzd"
      let params = { code: event.data.code }
      this.$refs.dingding.setLoading(true);
      const res = await httpPostSecret(url, params)
      this.$refs.dingding.setLoading(false);
      this.nextResultStep(res)
    });
  },
  methods: {
    //这个函数就是触发验证图片弹出来的,可以绑定给你想要触发的某个按钮
    refreshCode() {
      this.successVerify()
    },
    //验证成功或者手动时，关闭遮罩层
    offMask() {
      this.isShowSlide = false
    },

    //右滑验证成功或者不成功逻辑
    successVerify(msg) {
      if (msg) {
        this.isShowSlide = false
        this.resetCode()
        if (this.showVerify){
          this.yzm()
        }else {
          this.confirmSubmit()
        }
      }
      else {
        this.isShowSlide = true
        this.$refs.sliderChild.uploadSlideVerificationCode()
      }
    },

    //刷新验证码
    resetCode() {
      //这个验证码刷新具体看你项目的需要格式
    },

    onSlide() {
      if (this.submitTag) {
        return true
      }

      if (this.NONES.includes(this.username)) {
        this.$message.error('用户名不能为空');
        return false;
      }

      if (this.NONES.includes(this.password2)) {
        this.$message.error('密码不能为空');
        return false;
      }

      this.refreshCode()
    },


    onSubmit() {
      if (this.NONES.includes(this.username)) {
        this.$message.error('用户名不能为空');
        return false;
      }

      if (this.NONES.includes(this.password2)) {
        this.$message.error('密码不能为空');
        return false;
      }

      if (this.NONES.includes(this.password1) && this.showVerify) {
        this.$message.error('验证码不能为空');
        return false;
      }

      if (this.showVerify) {
        this.confirmSubmit()
      } else {
        this.refreshCode()
      }


    },
    async confirmSubmit() {
      this.submitTag = true
      this.passwordDisabled1 = true
      this.passwordDisabled2 = true
      this.fullscreenLoading = true;

      const url = "/api/user/login"
      let params = { userName: this.username, password: this.password2, smsCode: this.password1 }
      const res = await httpPostSecret(url, params)
      this.fullscreenLoading = false;

      this.passwordDisabled1 = false
      this.passwordDisabled2 = false

      this.nextResultStep(res)
    },

    nextResultStep(res) {
      if (res.rspCode === "000000") {
        const callback = getQueryString('callback')
        location.replace(callback || res.data);
      } else {
        this.$message.error(res.rspMsg);
        this.inputFocus()
      }
    },

    inputFocus() {
      window.addEventListener('input', () => {
        this.submitTag = false
      })
    },


    changePw() {
      if (this.passwordType === 'password') {
        this.passwordType = 'text'
        this.imgEyeSrc = require("../../assets/images/icon-eye_open.png")
      } else {
        this.passwordType = 'password'
        this.imgEyeSrc = require("../../assets/images/icon-eye_close.png")
      }
    },
    // 获取验证码
    async yzm() {
      let time = 60;
      let timer = null;
      if (this.NONES.includes(this.username)) {
        return false;
      }
      this.verificationDisabled = true
      const url = "/api/user/sendSms"
      let params = { username: this.username, password: this.password2, smsCode: this.password1 }
      const res = await httpPostSecret(url, params)
      this.fullscreenLoading = false;

      if (res.rspCode === "000000") {
        this.$notify({
          title: '温馨提示',
          message: `请输入${res.data}收到的验证码`,
          duration: 10000,
          type: 'warning'
        });
        timer = setInterval(() => {
          if (time > 0) {
            time -= 1;
            this.verification = time + 's'
          } else {
            this.verification = "获取验证码"
            this.verificationDisabled = false
            clearInterval(timer);
          }
        }, 1000)
      } else {
        this.$message.error(res.rspMsg);
        this.verificationDisabled = false
        this.verification = '获取验证码'
      }
    },
    getParaByName(name) {
      var search = window.location.search;
      search = search.substr(1);
      if (typeof name === 'undefined') return search;
      var searchArr = search.split('&');
      for (var i = 0; i < searchArr.length; i++) {
        var searchStr = searchArr[i];
        searchArr[i] = searchStr.split('=');
        if (searchArr[i][0] == name) {
          return searchStr.replace(name + '=', '');
        }
      }
      return '';
    },
    getQueryString(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },

    handleRegister() {
      this.$router.push('/register')
    },
    handleForget() {
      this.forgetFormShow = true
      this.logFormShow = false
    },
    handleCancel() {
      this.forgetFormShow = false
      this.logFormShow = true
    },

    handleErweima() {
      this.toggleBg = true
      setTimeout(() => {
        this.toggleBg = false
        this.firstContent = "ewm"
      }, 1000)
    },

    handleAccountIcon() {
      setTimeout(() => {
        this.firstContent = "form"
      }, 1000)
    },

  },
};
</script>

<style lang="less" scoped>
@import "../index.less";
@import "./styles.less";

page {
  background-color: #1f5ad8;
}

.mask {
  position: fixed;
  left: 0%;
  top: 0%;
  width: 100%;
  height: 100%;
  z-index: 499;
  overflow: hidden;
  // background-color: rgba(218, 238, 255, 0.9);
}

.slideContainer {
  background: #fff;
  padding: 15px;
  position: fixed;
  right: 32%;
  transform: translateX(300px);
  top: 50%;
  z-index: 999;
  box-shadow: 0 0 20px #aaa;
  border-radius: 8px
}

::v-deep {
  .el-notification__content{
    word-break: break-all;
  }
}
</style>
